// extracted by mini-css-extract-plugin
export var htmlPreview = "_os-2";
export var modal = "_os-0";
export var sidebar = "_os-1";